const PARAGRAPH_BET_CALCULATOR = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    type
    uuid
    id
    title
    ... on BetCalculator {
      id
      heading
      clearButtonLabel
      definition
      introduction
      linksHeading
      oddsAddLabel
      oddsFormatLabel
      oddsFormatOptions
      oddsLabel
      oddsPlaceholder
      otherTools {
        toolIcon
        toolLink
        toolTitle
      }
      payoutLabel
      stakeLabel
      stakePlaceholder
      title
      type
      uuid
    }
  }
`;

export default PARAGRAPH_BET_CALCULATOR;
